(() => {
  if (window.soneeMegamenuMasonryInitialized) return;
  window.soneeMegamenuMasonryInitialized = true;

  const menuGroups = new WeakMap();
  const selector = '#SiteHeader .sonee-explore-nav';
  const desktop = window.matchMedia('(min-width: 769px)');
  const compact = window.matchMedia('(max-width: 1100px)');

  function layoutMenu(nav) {
    if (!desktop.matches || !nav.closest('details')?.open) return;

    let groups = menuGroups.get(nav);
    if (!groups) {
      groups = Array.from(nav.children).filter((child) => child.classList.contains('megamenu__column'));
      menuGroups.set(nav, groups);
    }

    const gap = compact.matches ? 18 : 24;
    const limit = compact.matches ? 3 : 6;
    const count = Math.min(limit, Math.max(1, Math.floor((nav.clientWidth + gap) / (180 + gap))));
    nav.style.setProperty('--sonee-menu-columns', count);

    const stacks = Array.from({ length: count }, () => {
      const stack = document.createElement('div');
      stack.className = 'sonee-explore-stack';
      return stack;
    });
    nav.replaceChildren(...stacks);

    groups.forEach((group, index) => {
      const stack = index < count
        ? stacks[index]
        : stacks.reduce((shortest, candidate) =>
            candidate.getBoundingClientRect().height < shortest.getBoundingClientRect().height
              ? candidate
              : shortest
          );
      stack.appendChild(group);
    });
  }

  function initializeMenus(root = document) {
    root.querySelectorAll(selector).forEach((nav) => {
      if (nav.dataset.soneeMasonryReady) return;
      nav.dataset.soneeMasonryReady = 'true';
      const details = nav.closest('details');
      if (!details) return;

      new MutationObserver(() => layoutMenu(nav)).observe(details, {
        attributes: true,
        attributeFilter: ['open']
      });
      layoutMenu(nav);
    });
  }

  let resizeFrame;
  window.addEventListener('resize', () => {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(() => document.querySelectorAll(selector).forEach(layoutMenu));
  });
  document.addEventListener('shopify:section:load', () => initializeMenus());

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeMenus(), { once: true });
  } else {
    initializeMenus();
  }
})();
